/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Unlimited_ResumesInputs */

const en_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited resumes`)
};

const de_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte Lebensläufe`)
};

const fr_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV illimités`)
};

const es_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículums ilimitados`)
};

const it_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum illimitati`)
};

const nl_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbeperkte CV's`)
};

const pl_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nielimitowana liczba CV`)
};

const fi_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rajatonta ansioluetteloita`)
};

const da_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubegrænsede CV'er`)
};

const sv_pricing_feature_unlimited_resumes = /** @type {(inputs: Pricing_Feature_Unlimited_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obegränsat antal CV`)
};

/**
* | output |
* | --- |
* | "Unlimited resumes" |
*
* @param {Pricing_Feature_Unlimited_ResumesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_unlimited_resumes = /** @type {((inputs?: Pricing_Feature_Unlimited_ResumesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Unlimited_ResumesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_unlimited_resumes(inputs)
	if (locale === "fr") return fr_pricing_feature_unlimited_resumes(inputs)
	if (locale === "es") return es_pricing_feature_unlimited_resumes(inputs)
	if (locale === "it") return it_pricing_feature_unlimited_resumes(inputs)
	if (locale === "nl") return nl_pricing_feature_unlimited_resumes(inputs)
	if (locale === "pl") return pl_pricing_feature_unlimited_resumes(inputs)
	if (locale === "fi") return fi_pricing_feature_unlimited_resumes(inputs)
	if (locale === "da") return da_pricing_feature_unlimited_resumes(inputs)
	if (locale === "sv") return sv_pricing_feature_unlimited_resumes(inputs)
	return en_pricing_feature_unlimited_resumes(inputs)
});